'use client'

import React from 'react'

import { GeneralInformation } from '@/payload-types'
import { CMSLink } from '../../../components/CMSLink'
import { Media } from '../../Media/Media'
import { Logo } from '../Logo'
import Link from 'next/link'

export const HeaderDesktop = ({ data }: { data: GeneralInformation }) => {
  const { navigationItems, logo } = data || []

  const navigationLeft = navigationItems?.filter((navItem) => navItem.linkLocation === 'left')
  const navigationRight = navigationItems?.filter((navItem) => navItem.linkLocation === 'right')

  return (
    <div>
      <nav
        id="nav-bar"
        className="
          absolute top-0 left-0 w-full z-50
          lg:flex lg:flex-row
          justify-between items-center
          py-4
          text-xl lg:gap-4
          hidden
          shadow text-white
          bg-gray-400/50
          text-nowrap
        "
      >
        <div className="flex items-center lg:px-32 w-full">
          <div className="flex items-center gap-8 w-full">
            {logo && (
              <Link href="/">
                <Media resource={logo} className="w-40 shrink-0" />
              </Link>
            )}
            <div className="flex items-center justify-between w-full">
              <div className="flex justify-between items-center gap-7">
                {navigationItems &&
                  navigationLeft &&
                  navigationLeft.map((navItem) => {
                    if (!navItem.linkWithMedia) return null

                    return (
                      <div key={navItem.id} className="flex items-center">
                        {navItem.linkWithMedia.media && (
                          <Media
                            resource={navItem.linkWithMedia.media}
                            imgClassName="w-7 mr-2 shrink-0"
                          />
                        )}
                        <CMSLink {...navItem.linkWithMedia} className="text-sm" />
                      </div>
                    )
                  })}
              </div>
              <div className="flex justify-between items-center gap-7">
                {navigationItems &&
                  navigationRight &&
                  navigationRight.map((navItem) => {
                    if (!navItem.linkWithMedia) return null

                    return (
                      <div key={navItem.id} className="flex items-center">
                        {navItem.linkWithMedia.media && (
                          <Media
                            resource={navItem.linkWithMedia.media}
                            imgClassName="w-7 mr-2 shrink-0"
                          />
                        )}
                        <CMSLink {...navItem.linkWithMedia} className="text-sm" />
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}
